(() => {
  const CHECKOUT_SELECTOR = '[data-jarde-checkout]';

  let checkoutInProgress = false;

  function isAreaPricedItem(item) {
    const properties = item?.properties || {};

    const width = Number.parseFloat(
      properties['Wall Width (cm)']
    );

    const height = Number.parseFloat(
      properties['Wall Height (cm)']
    );

    return Boolean(
      properties['_Calculated Total'] &&
      properties['Material'] &&
      Number.isFinite(width) &&
      width > 0 &&
      Number.isFinite(height) &&
      height > 0
    );
  }

  function hasAreaPricedItem(cart) {
    return Boolean(
      cart?.items?.some(isAreaPricedItem)
    );
  }

  async function getCart() {
    const root =
      window.Shopify?.routes?.root || '/';

    const response = await fetch(
      `${root}cart.js`,
      {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {
          Accept: 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error(
        `Could not read cart (${response.status}).`
      );
    }

    return response.json();
  }

  function setButtonBusy(button, busy) {
    if (!button) return;

    if (busy) {
      button.dataset.jardeWasDisabled =
        button.disabled ? 'true' : 'false';

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    } else {
      if (
        button.dataset.jardeWasDisabled !== 'true'
      ) {
        button.disabled = false;
      }

      delete button.dataset.jardeWasDisabled;
      button.removeAttribute('aria-busy');
    }
  }

  async function startCheckout(button) {
    if (checkoutInProgress) return;

    checkoutInProgress = true;
    setButtonBusy(button, true);

    try {
      let cart = await getCart();
      if (window.JardeMuanceBasket?.repairNativeCart) cart=await window.JardeMuanceBasket.repairNativeCart(cart);
      if (cart.items.some(item => String(item.vendor || '').toLowerCase() === 'muance' &&
          item.properties?.['Mural Format'] === 'Custom Size')) {
        throw new Error('Remove legacy Muance Custom Size lines from your Shopify cart before checkout.');
      }
      const shadow = window.JardeMuanceBasket
        ? await window.JardeMuanceBasket.checkoutItems()
        : [];
      const nativeTotal=cart.total_price;
      let expectedTotal;
      if (shadow.length) {
        const currency=String(window.Shopify?.currency?.active || '').toUpperCase();
        const country=String(document.documentElement.dataset.jardeCountry || '').toUpperCase();
        if (cart.currency !== currency || !/^[A-Z]{2}$/.test(country) ||
            shadow.some(item=>item.properties['_Jarde Quote Currency'] !== currency)) throw new Error('Your Shopify market changed. Refresh the basket.');
        expectedTotal=nativeTotal+shadow.reduce((sum,item)=>sum+Math.round(Number(item.properties['_Jarde Quote Amount'])*100)*item.quantity,0);
        cart.country=country;
        cart.items = [...cart.items, ...shadow];
      }

      /*
       * Normal carts must keep Shopify's original
       * checkout behaviour completely unchanged.
       */
      if (!hasAreaPricedItem(cart)) {
        setButtonBusy(button, false);
        checkoutInProgress = false;

        button.dataset.jardeCheckoutBypass = 'true';
        button.click();

        return;
      }

      const options={method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(cart)};
      const response = shadow.length && window.JardeStagingTransport
        ? Response.json(await window.JardeStagingTransport.request('/apps/jarde-pricing/checkout',options))
        : await fetch('/apps/jarde-pricing/checkout',options);

      const responseText =
        await response.text();

      let result;

      try {
        result = JSON.parse(responseText);
      } catch {
        throw new Error(
          'Pricing Bridge returned an invalid response.'
        );
      }

      if (
        !response.ok ||
        !result?.ok ||
        !result?.checkoutUrl
      ) {
        throw new Error(
          result?.error ||
          'Checkout could not be created.'
        );
      }

      if (shadow.length) {
        const destination=new URL(result.checkoutUrl);
        if (!(result.checkoutMode === 'private-draft' || (window.JardeStagingTransport && result.checkoutMode === 'area-draft')) || result.currency !== cart.currency ||
            cart.currency !== String(window.Shopify?.currency?.active || '').toUpperCase() ||
            cart.country !== String(document.documentElement.dataset.jardeCountry || '').toUpperCase() ||
            !Number.isFinite(expectedTotal) || Math.round(Number(result.total)*100) !== expectedTotal || destination.protocol !== 'https:' ||
            !['jarde.co.uk','yufqry-im.myshopify.com','checkout.shopify.com'].includes(destination.hostname))
          throw new Error('Shopify returned a different Custom total, currency or checkout address. An unpaid draft may exist; do not retry blindly.');
      }
      window.location.assign(
        result.checkoutUrl
      );
    } catch (error) {
      console.error(
        '[JARDE Pricing Bridge]',
        error
      );

      setButtonBusy(button, false);
      checkoutInProgress = false;

      window.alert(
        error.message || 'Checkout failed. An unpaid draft may exist; do not retry blindly.'
      );
    }
  }

  document.addEventListener(
    'click',
    (event) => {
      const button =
        event.target.closest(
          CHECKOUT_SELECTOR
        );

      if (!button) return;

      /*
       * Allows the original Shopify checkout
       * to continue for carts with no area-priced mural.
       */
      if (
        button.dataset
          .jardeCheckoutBypass === 'true'
      ) {
        delete button.dataset
          .jardeCheckoutBypass;

        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      startCheckout(button);
    },
    true
  );
})();